/**
 * Loads the Pinterest Tag script and sends events passed down by the server
 */

import { MiaPlaza } from "@/Reinforced.Typings";
import Log from "@/utils/Log";

export default class PinterestTag {
	private readonly options: MiaPlaza.Control.Tracking.IPinterestTagTrackingOptions;
	private loaded = false;

	constructor(options: MiaPlaza.Control.Tracking.IPinterestTagTrackingOptions) {
		this.options = options;
	}

	public load(): void {
		if (this.loaded) {
			return;
		}

		if (!this.options?.Id || this.options?.Events?.length === 0) {
			return;
		}

		const pinterestTagJs = "!function(e){if(!window.pintrk){window.pintrk=function(){window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var n=window.pintrk;n.queue=[],n.version=\"3.0\";var t=document.createElement(\"script\");t.async=!0,t.src=e;var r=document.getElementsByTagName(\"script\")[0];r.parentNode.insertBefore(t,r)}}(\"https://s.pinimg.com/ct/core.js\");";
		(new Function(pinterestTagJs))();

		// The script in 'pinterestTagJs' variable creates a 'pintrk' function on 'window' immediately.
		// This check ensures the function is present and callable.
		if (typeof (window as any).pintrk !== "function") {
			void Log.error("Pinterest Tag: 'pintrk' function is not available after loading the script.");
			return;
		}

		this.loaded = true;

		// according to https://help.pinterest.com/en/business/article/install-the-base-code
		// we should first call setconsent when we received consent from customer
		// but as we show OneTrust cookie consent banner before loading any tracking scripts, we can assume consent is given when this code runs
		// therefore we call setconsent with 'true' value here imimediatelly
		// if setconsent is not called, Pinterest Tag will not track any events
		pintrk("setconsent", true);
		pintrk("load", this.options.Id);
		pintrk("page");

		for (const event of this.options.Events) {
			pintrk("track", event.EventType, JSON.parse(event.CustomData));
		}
	}
}
